import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../translation/translation';
import {Filters} from '../../../constants/filter/filters';

function VehicleList(props) {
    let i = 0;
    let renderData =  props.vehicleData.map( item => {
        let isLast = props.vehicleData.length === (i + 1);
        i++;
        return (
            <div onClick={() => props.onSelectVehicle(item)} className={'rego-lookup-vehicle-data'} id={'vehicle-' + item[Filters.VEHICLE_ID]} key={item[Filters.VEHICLE_ID]}>
                <p id='rego-lookup-make'>
                    <Translation translationKey={'rego-lookup-confirmation-layer-label-make'}/>
                    {item[Filters.VEHICLE_MAKE]}
                </p>
                <p id='rego-lookup-model-details'>
                    <Translation translationKey={'rego-lookup-confirmation-layer-label-model'}/>
                    {item[Filters.VEHICLE_MODEL]}
                </p>
                <p id='rego-lookup-year'>
                    <Translation translationKey={'rego-lookup-confirmation-layer-label-year-range'}/>
                    {item[Filters.VEHICLE_YEAR_RANGE_FROM].substring(0, 4)} {item[Filters.VEHICLE_YEAR_RANGE_TO] ? '-' : ''} {(item[Filters.VEHICLE_YEAR_RANGE_TO] || '').substring(0, 4)}
                </p>
                {!isLast && <hr />}
            </div>
        )
    });

    return renderData;
}

VehicleList.propTypes = {
    vehicleData: PropTypes.array.isRequired,
    onSelectVehicle: PropTypes.func.isRequired,
};

export default VehicleList;